import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';

import { initLogRocket, LogRocket, getId } from './logrocket';
import { ACCESS_TOKEN_KEY } from '@/constants';
import { parseJwt } from '@shared/auth';

const id = getId();
export function SessionTracker() {
	const location = useRouterState({ select: (s) => s.location });

	// Initialize LogRocket once
	useEffect(() => {
		if (!id) {
			return;
		}
		initLogRocket();
	}, []);

	// Track route changes
	useEffect(() => {
		if (!id) return;
		const path = location.pathname + location.search + location.hash;

		LogRocket.track(`navigated: ${path}`);
	}, [location.pathname, location.search, location.hash]);

	useIdentifyUser();

	return null;
}

function useIdentifyUser() {
	const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
	useEffect(() => {
		if (!id) return;
		if (!accessToken) {
			return;
		}
		const data = parseJwt(accessToken);
		const {
			sub,
			aud,
			email,
			iss,
			amr,
			isAdmin,
			entitlements,
			subscriptions,
		} = data;
		LogRocket.identify(sub, {
			aud,
			email,
			iss,
			amr,
			isAdmin,
			entitlements,
			subscriptions,
		});
	}, [accessToken]);
}
